import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { DemoModalProvider } from "@/components/marketing/DemoModal";
import Home from "@/pages/Home";
import AuthPlaceholder from "@/pages/AuthPlaceholder";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminEditor from "@/pages/admin/AdminEditor";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ anchors: true, lerp: 0.11 });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <DemoModalProvider>
                    <ScrollManager />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/signup" element={<AuthPlaceholder mode="signup" />} />
                        <Route path="/login" element={<AuthPlaceholder mode="login" />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminBlog />} />
                        <Route path="/admin/blog/new" element={<AdminEditor />} />
                        <Route path="/admin/blog/edit/:id" element={<AdminEditor />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                    <Toaster position="top-center" richColors />
                </DemoModalProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
